import { Observable } from 'rxjs';
export abstract class SubtasksHttpService {
	abstract getSubtasks(
		taskId: string | number,
		startRow: number,
		endRow: number,
		getRootTask: boolean
	): Observable<ISubtasksData>;
	abstract deleteSubtask(taskId: number, subtaskId: number): Observable<any>;
	abstract getRootId(taskId: number);
}

export interface ISubtask {
	id: number;
	parentId?: number;
	description: string;
	stateName: string;
	isClosed: boolean;
	subCat: string;
	hasChildren: boolean;
	group?: boolean;
	hasRightsToUnlink: boolean;
	subtaskId: number;
}

export interface ISubtasksData {
	subtasks?: ISubtask[];
	lastRow: number;
}
